export const CUSTOM_PRICE_FIELD_NAME = 'customPrice';

// Stripe caps an invoice line at 99,999,999 minor units.
export const STRIPE_MAX_CUSTOM_PRICE = 999_999;

// CreateOrderReq.CustomPrice is a uint32.
export const MAX_CUSTOM_PRICE = 4_294_967_295;
